<template>
  <div class="language-dropdown flex-center">
    <span
      class="flag-icon flag-icon-large"
      :class="flagIconClass(currentLanguage())"
    />
    <vuestic-dropdown
      class="language-dropdown__container"
      v-model="isShown"
      position="bottom"
    >
      <a class="dropdown-item"
         v-for="(option, id) in options"
         :key="id"
         :class="{ active: option.code === currentLanguage() }"
         @click="setLanguage(option.code)"
      >
        <span class="flag-icon flag-icon-small"
              :class="flagIconClass(option.code)"></span>
        <span class="dropdown-item__text ellipsis">
          {{ `language.${option.name}` | translate }}
        </span>
      </a>
    </vuestic-dropdown>
  </div>
</template>

<script>
import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import { setStoredLocale } from '@/i18n/localeStorage'

// Flag icon codes differ from vuex-i18n locale codes for some languages.
const FLAG_TO_LOCALE = {
  gb: 'en',
  cn: 'zh',
  br: 'br',
  es: 'es',
}
const LOCALE_TO_FLAG = {
  en: 'gb',
  zh: 'cn',
  br: 'br',
  es: 'es',
}
const ELEMENT_LOCALES = {
  en: enLocale,
  zh: zhLocale,
}

export default {
  name: 'language-dropdown',
  data () {
    return {
      isShown: false,
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          code: 'gb',
          name: 'english',
        },
        // {
        //   code: 'es',
        //   name: 'spanish',
        // },
        {
          code: 'br',
          name: 'brazilian_portuguese',
        },
        {
          code: 'cn',
          name: 'chinese',
        },
      ],
    },
  },
  methods: {
    setLanguage (flagCode) {
      const i18nLocale = FLAG_TO_LOCALE[flagCode] || flagCode
      Vue.i18n.set(i18nLocale)
      setStoredLocale(i18nLocale)
      const elementLocale = ELEMENT_LOCALES[i18nLocale] || enLocale
      locale.use(elementLocale)
    },

    currentLanguage () {
      return LOCALE_TO_FLAG[Vue.i18n.locale()] || Vue.i18n.locale()
    },

    flagIconClass (code) {
      return `flag-icon-${code}`
    },
  },
}
</script>

<style lang="scss">
@import '../../../../../vuestic-theme/vuestic-sass/resources/resources';
@import "~flag-icon-css/css/flag-icon.css";

.language-dropdown {
  cursor: pointer;
  .flag-icon-large {
    display: block;
    width: 31px;
    height: 23px;
  }

  @at-root {
    &__container {
      .flag-icon-small {
        min-width: 22px;
        height: 17px;
        margin-right: 12px;
      }
    }
  }
}
</style>
